import { FC } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { RootState } from "../../../store/rootReducer";
import Button from "../../Button";
import SelectCampus from "../../SelectCampus";
import SelectCampusForHq from "../../SelectCampusForHQ";
import SelectLevelWithAll from "../../SelectLevelWithAll";

interface IProps {
  campusCode: string;
  setCampusCode: (campusCode: string) => void;
  courseCode: string;
  setCourseCode: (courseCode: string) => void;
  onSearch: () => void;
}

const ResultSearchBar: FC<IProps> = ({
  campusCode,
  setCampusCode,
  courseCode,
  setCourseCode,
  onSearch,
}) => {
  const { t } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);  

  return (
    <div >
      <div className="flex">
        <div className="v-line mr-1">{t('common.menu.campus')}</div>
        <div className="w-150p mr-2">
          {
            auth.hqYn === 'Y'
              ? (
                <SelectCampusForHq
                  campusCode={campusCode}
                  setCampusCode={setCampusCode}
                />
                )
              : <SelectCampus />
          }
        </div>
        <div className="v-line mr-1">{t('homepage.archive.column4')}</div>
        <div className="w-150p mr-2">
          <SelectLevelWithAll
            value={courseCode}
            setValue={e => setCourseCode(e)}
          />
        </div>
        <div className="comm-btn__area">
          <Button
            className="btn-basic small black"
            onClick={onSearch}
            text={t('common.button.search')}
          />
        </div>
      </div>
    </div>
  );
}

export default ResultSearchBar;
